import { render } from "./Iban.vue?vue&type=template&id=14b16152"
import script from "./Iban.vue?vue&type=script&lang=js"
export * from "./Iban.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__